import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar";
import HeroSection from "./components/heroSection";
import ProductSection from "./components/productSection";
import JourneySection from "./components/OurJourney";
import OurActivities from "./components/OurActivities";
import Footer from "./components/footer";
import ProductBMS from "./components/ProductBMS";
import ProductDAS from "./components/ProductDAS";
import ProductDAS48 from "./components/ProductDAS48";
import ProductDMS from "./components/ProductDMS";
import ProductWaterMeter from "./components/ProductWater";
import ProductsHmi from "./components/HMIomc";
import ProductsHmiIot from "./components/HMIIot";
import ProductsHmiScada from "./components/HMIScada";
import ProductsDCU from "./components/ProductDCU";
import ScrollToTop from "./components/ScrollTop";
import { LanguageProvider } from "./LanguageContext"; 
import Productmon from "./components/ProductMon";

function HomePage() {
  return (
    <div className="relative">
      <section id="home">
        <HeroSection />
      </section>

      <div className="px-4 sm:px-8 md:px-12 lg:px-16 xl:px-20 max-w-[1440px] mx-auto">
        <section id="products">
          <ProductSection />
        </section>

        <section id="journey">
          <JourneySection />
        </section>

        <section id="activities">
          <OurActivities />
        </section>

        <section id="footer">
          <Footer />
        </section>
      </div>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="overflow-x-hidden overflow-y-hidden">
        <Router>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/product/bms" element={<ProductBMS />} />
            <Route path="/product/das24p" element={<ProductDAS />} />
            <Route path="/product/das48" element={<ProductDAS48 />} />
            <Route path="/product/dms" element={<ProductDMS />} />
            <Route path="/product/watermeter" element={<ProductWaterMeter />} />
            <Route path="/product/hmiomc" element={<ProductsHmi />} />
            <Route path="/product/hmiIOT" element={<ProductsHmiIot />} />
            <Route path="/product/hmiscada" element={<ProductsHmiScada />} />
            <Route path="/product/monkwh" element={<Productmon />} />
            <Route path="/product/minidcu" element={<ProductsDCU />} />
          </Routes>
        </Router>
      </div>
    </LanguageProvider>
  );
}

export default App;
